<app-header></app-header>
<router-outlet></router-outlet>
<app-dailyoffers></app-dailyoffers>
<app-footer></app-footer>

<!-- Popup -->
<div class="install-overlay" *ngIf="showInstallPopup && isMobile" (click)="closeInstallPopup()">
  <div class="install-popup" (click)="$event.stopPropagation()">

    <button type="button" class="popup-close" (click)="closeInstallPopup()">
      ✕
    </button>

    <div class="popup-icon">
      <span>📱</span>
    </div>

    <h2 class="popup-title">
      {{ "Add to Home Screen" | transloco }}
    </h2>

    <p class="popup-text">
      ثبّت التطبيق على موبايلك علشان تفتحه بسرعة وتستخدمه بسهولة في أي وقت.
    </p>

    <button type="button" class="popup-action-btn" (click)="installPWA()">
      {{ "Add to Home Screen" | transloco }}
    </button>

  </div>
</div>